import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const TagNewIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper
      viewBox="0 0 20 20"
      {...props}
      fill="none"
      stroke={props.stroke ?? '#677383'}
    >
      <path
        d="M16.5866 10.9569L16.5638 7.1151C16.5583 6.1797 15.9051 5.37309 14.9913 5.17318L11.2382 4.35211C10.6446 4.22226 10.0243 4.36926 9.5521 4.75161L3.69339 9.4959C3.26418 9.84346 3.198 10.4732 3.54556 10.9024L8.58013 17.1195C8.92769 17.5487 9.55739 17.6149 9.98659 17.2674L15.8453 12.5231C16.3175 12.1407 16.5902 11.5645 16.5866 10.9569Z"
        stroke={props.stroke ?? '#677383'}
        strokeWidth="1.2"
      />
      <circle
        cx="12.8649"
        cy="8.48215"
        r="1"
        transform="rotate(51 12.8649 8.48215)"
        stroke={props.stroke ?? '#677383'}
      />
    </SvgWrapper>
  );
};
